import $ from 'jquery';
import mixitup from 'mixitup';
import 'slick-carousel';
import mixitupMultifilter from './vendor/mixitup-multifilter';
import mixitupPagination from './vendor/mixitup-pagination';

mixitup.use(mixitupMultifilter); 
mixitup.use(mixitupPagination);

var containerEl = document.querySelector('.mws-videos .cardContainer'); 
var filters = document.querySelectorAll('#mwsFilters button');
var mixer = mixitup(containerEl, {
  pagination: {
    limit: 15
  },
  multifilter: {
    enable: true
  },
  controls: {
    toggleLogic: "and"
  },
  callbacks: {
    onMixEnd: function (state) {
      document.getElementById('mwsFilters').scrollIntoView({block: 'start', behavior: 'smooth'}); 
      if (state.hasFailed) {
        noItemsFoundMessage.style.display = "flex";
      }
      else {
        noItemsFoundMessage.style.display = "none";
      }
    },
  } //end of callbacks
});

// Trigger 
const mwsFiltersTrigger = document.getElementById("mwsFiltersTrigger");
const mwsFilters = document.getElementById("mwsFilters");

mwsFiltersTrigger.addEventListener("click", function () {
  if (this.classList.contains('visible') || mwsFilters.classList.contains('visible')) {
    this.classList.remove("visible");
    this.setAttribute("aria-expanded", "false");
    mwsFilters.classList.remove("visible");
  } else {
    this.classList.add("visible");
    this.setAttribute("aria-expanded", "true");
    mwsFilters.classList.add("visible");
  }
});


// slider
var slick_slider = $('.mws-featured .cardContainer');
var settings_slider = {
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: true,
  dots: false
}

slick_on_mobile( slick_slider, settings_slider);

// slick on mobile
function slick_on_mobile(slider, settings){
  $(window).on('load resize', function() {
    if ($(window).width() > 900) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  });
};

// Display options for video grid
const videos = document.getElementById('mws-videos');
const sortBtns = document.querySelectorAll('.mws-filters--right button');

for (var i = 0; i < sortBtns.length; i++) {
  sortBtns[i].addEventListener('click', function () {
    for (var i = 0; i < sortBtns.length; i++) {
      sortBtns[i].classList.remove('active');
    }
    this.classList.add('active');
    const sortType = this.dataset.value; 
    window.localStorage.setItem('display', sortType);
    videos.setAttribute("data-display", sortType);
  })
}

window.addEventListener('load', (event) => {
  const st = window.localStorage.getItem('display');
  if (st == "list") {
    for (var i = 0; i < sortBtns.length; i++) {
      sortBtns[i].classList.remove('active');
    }
    document.querySelector('.mws-filters-list').classList.add('active');
    videos.setAttribute("data-display", "list");
  }
});

// Change to grid view if screen is sized down
window.addEventListener('resize', function() {
  if (window.matchMedia("(max-width: 800px)").matches) {
    document.querySelector('.mws-filters-list').classList.remove('active');
    document.querySelector('.mws-filters-grid').classList.add('active');
    videos.setAttribute("data-display", "grid");
  }
});

// Show Clear Filter Button when something is selected from filters
const assetMenu = document.getElementById('assetIndustry');
const featureMenu = document.getElementById('assetFeature');
const clearFilters = document.getElementById('mws-filters-clear');
const assetFilters= document.querySelectorAll('.mws-filters--left select');
// const showAllButton = document.querySelector('.mws-filters--left button[data-filter="all"');

for (var i = 0; i < assetFilters.length; i++) {
  assetFilters[i].addEventListener("change", function() {
    if (assetMenu.value != '' || featureMenu.value != '') {
      // clearFilters.style.display = 'inline-block';
      this.classList.add('active');
      // showAllButton.classList.add('btn-ghost');
    }
  })
};

clearFilters.addEventListener('click', function() {
  // showAllButton.classList.remove('btn-ghost');

  for (var i = 0; i < assetFilters.length; i++) {
    assetFilters[i].classList.remove('active');
  } 
});

